import { render } from "./chat_list.vue?vue&type=template&id=0122a3a1&scoped=true"
import script from "./chat_list.vue?vue&type=script&lang=js"
export * from "./chat_list.vue?vue&type=script&lang=js"

import "./chat_list.vue?vue&type=style&index=0&id=0122a3a1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0122a3a1"]])

export default __exports__